import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { JobHistory } from 'modules/ManageJobs/JobHistory/types/JobHistory';
import { useQuery } from 'react-query';
import { axiosClient } from './axiosClient';

const resource = '';

const jobHistory = {
  GetJobHistories() {
    const [dataEnvironment] = useDataEnvironment();
    return useQuery(['job_histories', dataEnvironment?.id], () =>
      axiosClient.get<JobHistory[]>(
        `${resource}/${dataEnvironment?.id}/job_histories`
      )
    );
  },
  DownloadDiagnostics(id: string) {
    const [dataEnvironment] = useDataEnvironment();
    return axiosClient.get(
      `/${dataEnvironment?.id}/job_histories/${id}/audit_files`,
      {
        responseType: 'blob',
      }
    );
  },
};

export default jobHistory;
